import { render, staticRenderFns } from "./deanAlertDialog.vue?vue&type=template&id=169e0d37&scoped=true"
import script from "./deanAlertDialog.vue?vue&type=script&lang=ts"
export * from "./deanAlertDialog.vue?vue&type=script&lang=ts"
import style0 from "./deanAlertDialog.vue?vue&type=style&index=0&id=169e0d37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169e0d37",
  null
  
)

export default component.exports